import { Button, makeStyles, Toolbar } from "@material-ui/core";
import { useQuery } from "@redux-requests/react";
import { uniq } from "lodash";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { BaseLayout, Header, Loader, NoData, SponsorList } from "../components";
import { getProgramSlots } from "../ducks/actions/program";
import * as types from "../ducks/types";
import { ProgramSlot, SessionDialog } from "../features/program";
import { useQueryParams } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    "& > *": {
      marginBottom: theme.spacing(3)
    }
  },
  dayButton: {
    marginLeft: theme.spacing(2)
  },
  toolbar: {
    overflow: "auto",
    "& > *": {
      flexGrow: 0,
      flexShrink: 0,
      flexBasis: "auto"
    }
  }
}));

const ProgramPage = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const classes = useStyles();

  useEffect(() => {
    dispatch(getProgramSlots());
  }, [dispatch]);

  const [{ day }, mergeParams] = useQueryParams();

  const {
    data: { data: programSlots },
    loading
  } = useQuery({ type: types.GET_PROGRAM_SLOTS, defaultData: { data: [] } });

  const days = uniq(programSlots.map(({ startAt }) => moment(startAt).format("DD/MM/YYYY")));

  useEffect(() => {
    const today = moment().format("DD/MM/YYYY");
    if (!day && days.includes(today)) {
      mergeParams({ day: today });
    }
  }, [mergeParams, days, day]);

  const onDaySelect =
    ({ selectedDay }) =>
    () => {
      mergeParams({ day: selectedDay });
    };

  const [sessionId, setSessionId] = useState(null);
  const onSessionOpen =
    ({ id }) =>
    () => {
      setSessionId(id);
    };
  const onSessionClose = () => {
    setSessionId(null);
  };

  return (
    <BaseLayout className={classes.root}>
      <Header
        icon="calendar"
        title={intl.formatMessage({ id: "Pages.ProgramPage.Program", defaultMessage: "Program" })}
      />
      <Loader loading={loading}>
        <NoData
          message={intl.formatMessage({
            id: "Pages.ProgramPage.NoProgramSlot",
            defaultMessage: "The program hasn't been established. Please check later..."
          })}
          data={programSlots}
        >
          <Toolbar className={classes.toolbar}>
            {days.map(d => (
              <Button
                key={d}
                onClick={onDaySelect({ selectedDay: d })}
                className={classes.dayButton}
                variant={(day || days[0]) === d ? "contained" : "text"}
                color="primary"
              >
                {d}
              </Button>
            ))}
          </Toolbar>
          {programSlots
            .filter(({ startAt }) => moment(startAt).format("DD/MM/YYYY") === (day || days[0]))
            .map(({ id, label, startAt, endAt }, i) => (
              <ProgramSlot
                key={id}
                index={i}
                label={label}
                startAt={startAt}
                endAt={endAt}
                onSessionOpen={onSessionOpen}
              />
            ))}
        </NoData>
      </Loader>
      <SponsorList />
      {sessionId && <SessionDialog id={sessionId} onClose={onSessionClose} />}
    </BaseLayout>
  );
};

export default ProgramPage;
